import { Component, Input, TemplateRef, EventEmitter, Output } from "@angular/core";
import { WizardComponent } from "ngx-wizard";
import { Order } from "../../../../../objects/orders/order";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { OrderOptions } from "../../../../../objects/orders/orderOptions";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: 'how-carrying',
    templateUrl: 'how-carrying.component.html',
    moduleId: module.id.toString()
})
export class HowCarryingComponent {
    @Input()
    public wizardComponent: WizardComponent;

    @Input()
    public order: Order;
    @Input()
    public wizardFooterTemplate: TemplateRef<any>;
    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public isWhoShippingTabNeed: boolean = false;
    public orderOptions = OrderOptions;

    public showCarryingTrackOption: boolean = true;
    public showCarryingAirOption: boolean = true;
    public showCarryingOceanOption: boolean = true;

    public showShippingTab: boolean = true;
    public constructor(
        public googleTagService: GoogleTagService) {

    }

    /**
     * 0 - Truck
     * 1 - Air
     * 2 - Ocean
     */
    public howShipping: 1 | 2 | 3 | null;


    public setHowHipping(value: 1 | 2 | 3): void {
        if (this.howShipping == value) {
            this.howShipping = null;
            return;
        }

        this.howShipping = value;
    }

    public showCarryingOptions(): void{

        const shipToLoc = this.order.Locations.find(x => x.Type == 2);
        const shipFromLoc = this.order.Customer.Location.Country;

        if(shipFromLoc == "United States" && shipToLoc.Country == "Canada" || shipFromLoc == "Canada" && shipToLoc.Country == "United States"){
            
            this.showShippingTab = false;
            this.googleTagService.pushData('how-carrying');
            this.setHowHipping(1);
            this.setCarryingType();

        }else{
            this.showCarryingTrackOption = false;
            this.showCarryingAirOption = true;
            this.showCarryingOceanOption = true;
        }

        if(this.showShippingTab){
            setTimeout(_ => this.wizardComponent.nextTab(false), 0);
        }

    }
    
    public setCarryingType(): void {
        this.order.CarryingType = this.howShipping;

        if (!this.order.Flag)
            this.order.Flag = OrderOptions.None;

        if (this.order.CarryingType == 1) {
            this.isWhoShippingTabNeed = true;
        } else {
            this.isWhoShippingTabNeed = false;
        }

        if (this.howShipping == 3) {
            this.order.Flag |= OrderOptions.IsOcean;
        }
        else {
            this.order.Flag &= ~OrderOptions.IsOcean
        }

       setTimeout(_ => this.wizardComponent.nextTab(false), 0);
    }

    public showShippingTypeTab(){
        this.showShippingTab = true;
        this.isWhoShippingTabNeed = false;
        this.howShipping = null;
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/carrying/how-carrying.component.ts